import React from 'react'
import { Input } from 'reactstrap';


export const TableWorkOrderItem = (props) => {

    const {

        // * ACTIONS       
        removeExamProfile,
        handleCheckUrgent,
        handleViewExamsProfile,
        handleCheckSpecimen,
        handleCheckForwarded,
        showUrgenteColumn,

        // * ITEMS
        itemTest,
        checkTypeClient,
        availableRowsSpan = false,
        nameCampaign = "",
        availableByIndex = null,
        uniqueKey,

        // * VAR
        enable_tracking_toma,
        number_format,
        index,
        count,
        _active_returnStudies,
        isEdit,
        semlab,
        validPorcentejeSpecial

    } = props;
    console.log("🚀 ~ TableWorkOrderItem ~ validPorcentejeSpecial:", validPorcentejeSpecial)
    console.log("🚀 ~ TableWorkOrderItem ~ semlab:", semlab)
    console.log("🚀 ~ TableWorkOrderItem ~ itemTest:", itemTest)
    console.log("🚀 ~ TableWorkOrderItem ~ _active_returnStudies:", _active_returnStudies)
    console.log("🚀 ~ TableWorkOrderItem ~ isEdit:", isEdit)


    let ur_helen = localStorage.getItem('url_helen');

    // ? CONFIGURATION DEFAULT EXTERNAL
    if (ur_helen === "https://cedimi.helen-sw.com" && itemTest.is_referenced && itemTest.listExternalLaboratories !== null && itemTest.listExternalLaboratories.length > 1) {
        const _filter = itemTest.listExternalLaboratories.filter(_find => _find.default_lab);
        itemTest.listExternalLaboratories = _filter;
    }
    const formatMoney = (value) => {
        const rounded = Math.round(value);

        return new Intl.NumberFormat("es-MX", {
            style: "currency",
            currency: "MXN",
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(rounded);
    };
    return (
        <tr
            className={
                (itemTest.id_agreement === 0 || itemTest.id_agreement === null || itemTest.id_agreement === "0")
                    ? (itemTest.discount > 0 && itemTest.auto_redeem)
                        ? "bg-light-danger discountB"
                        : "border-bottom-info"
                    : "border-bottom-info"
            }
        >
            {
                // * CODE
            }
            <td className={itemTest.is_urgent ? "text-danger" : ""} style={{ verticalAlign: "middle" }}>
                {availableRowsSpan && availableByIndex === 0 ? (
                    <b>{nameCampaign}</b>
                ) : !availableRowsSpan ? (
                    itemTest.code
                ) : null}
            </td>
            {
                // * NAME TESTS
            }
            <td className={itemTest.is_urgent ? "text-danger" : ""} style={{ verticalAlign: "middle" }}>
                {availableRowsSpan ? `${itemTest.code} - ${itemTest.name}` : itemTest.name}

                {ur_helen !== "https://cedimi.helen-sw.com" && itemTest.is_referenced && (
                    <>
                        <br />
                        <span className='badge badge-primary'>
                            {itemTest.name_external_laboratory}
                        </span>
                    </>
                )}
            </td>
            {
                // * COST
            }
            {/* <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                <span className={`wo-price ${itemTest.is_urgent ? "urgent" : ""}`}>
                    {
                        (itemTest.id_agreement === null || itemTest.id_agreement === 0)
                            ? formatMoney(itemTest.price)
                            : formatMoney(itemTest.price_Agremment)
                    }
                </span>
            </td> */}
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                <span className={`wo-price ${itemTest.is_urgent ? "urgent" : ""}`}>
                    {
                        (itemTest.id_agreement === null || itemTest.id_agreement === 0)
                            ? formatMoney(
                                ur_helen === "https://semlab.helen-sw.com" &&
                                    itemTest.config_iva === false
                                    ? Number(itemTest.price || 0) *
                                    (1 + Number(itemTest.value_iva || 0) / 100)
                                    : itemTest.price
                            )
                            : formatMoney(itemTest.price_Agremment)
                    }
                </span>
            </td>

            {
                // * URGENT
            }
            {showUrgenteColumn && (
                <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                    {itemTest.id_agreement === null && (
                        <div className="wo-check">
                            <Input
                                type="checkbox"
                                id={`checkboxP-${uniqueKey}`}
                                className="wo-check-input"
                                checked={!!itemTest.is_urgent}
                                onChange={(e) =>
                                    handleCheckUrgent(e, itemTest.id_exam, itemTest.id_profile)
                                }
                                disabled={!!itemTest.discount || !!itemTest.id_preloaded_discount}
                            />
                            <label htmlFor={`checkboxP-${uniqueKey}`} className="wo-check-label">
                                <i className="pi pi-clock"></i>
                            </label>
                        </div>
                    )}
                </td>
            )}
            {
                // * SAMPLINGS
            }
            {(enable_tracking_toma !== true && enable_tracking_toma !== "True") && (
                <td style={{ verticalAlign: "middle" }}>
                    {itemTest.id_profile !== null ? (
                        itemTest.array_specimens?.map((x, i) => (
                            <div key={`spec-${uniqueKey}-${i}`} className="wo-check-specimen">
                                <Input
                                    id={`checkbox-${uniqueKey}-${i}`}
                                    className="wo-check-input"
                                    checked={!!x.check_specimen}
                                    onChange={() =>
                                        handleCheckSpecimen(null, itemTest.id_profile, x.id_specimen)
                                    }
                                    type="checkbox"
                                />
                                <label htmlFor={`checkbox-${uniqueKey}-${i}`} className="wo-check-label-specimen">
                                    <span className="wo-check-box"></span>
                                    <span className="wo-check-text">{x.specimen_name}</span>
                                </label>
                            </div>
                        ))
                    ) : (
                        <div className="wo-check-specimen">
                            <Input
                                id={`checkbox-${uniqueKey}`}
                                className="wo-check-input"
                                checked={!!itemTest.check_specimen}
                                onChange={() => handleCheckSpecimen(itemTest.id_exam)}
                                type="checkbox"
                            />
                            <label htmlFor={`checkbox-${uniqueKey}`} className="wo-check-label-specimen">
                                <span className="wo-check-box"></span>
                                <span className="wo-check-text">{itemTest.specimen_name}</span>
                            </label>
                        </div>
                    )}
                </td>
            )}
            {
                // * FORWARDED
            }
            {(enable_tracking_toma === true || enable_tracking_toma === "True") && (
                <td style={{ verticalAlign: "middle" }}>
                    {itemTest.id_profile !== null ? (
                        itemTest.array_specimens?.map((x, i) => (
                            <div key={`forw-${uniqueKey}-${i}`} className="wo-check-forwarded">
                                <Input
                                    id={`checkbox_re-${uniqueKey}-${i}`}
                                    className="wo-check-input"
                                    checked={!!x.check_forwarded}
                                    onChange={() =>
                                        handleCheckForwarded(null, itemTest.id_profile, x.id_specimen)
                                    }
                                    type="checkbox"
                                />
                                <label htmlFor={`checkbox_re-${uniqueKey}-${i}`} className="wo-check-label-forwarded">
                                    <span className="wo-check-dot"></span>
                                    <span className="wo-check-text">{x.specimen_name}</span>
                                </label>
                            </div>
                        ))
                    ) : (
                        <div className="wo-check-forwarded">
                            <Input
                                id={`checkbox_re-${uniqueKey}`}
                                className="wo-check-input"
                                checked={!!itemTest.check_forwarded}
                                onChange={() => handleCheckForwarded(itemTest.id_exam)}
                                type="checkbox"
                            />
                            <label htmlFor={`checkbox_re-${uniqueKey}`} className="wo-check-label-forwarded">
                                <span className="wo-check-dot"></span>
                                <span className="wo-check-text">{itemTest.specimen_name}</span>
                            </label>
                        </div>
                    )}
                </td>
            )}
            {
                // * AGREEMENT
            }
            {checkTypeClient === 3 && (
                <td className={itemTest.is_urgent ? "text-danger" : ""}>
                    {itemTest.id_agreement !== null && itemTest.id_agreement !== 0
                        ? itemTest.contract_number
                        : ""}
                </td>
            )}
            {
                // * ACTIONS
            }
            <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                <div className="wo-actions">
                    {itemTest.id_profile !== null && (
                        <button
                            className="wo-btn primary"
                            onClick={() => handleViewExamsProfile(itemTest.id_profile)}
                        >
                            <i className="icofont icofont-laboratory"></i>
                        </button>
                    )}

                    {
                        (!isEdit || _active_returnStudies === "True") &&
                        <button
                            className="wo-btn danger"
                            onClick={() => removeExamProfile(
                                itemTest.id_exam,
                                itemTest.id_profile,
                                index,
                                count,
                                itemTest.exist
                            )}
                        >
                            <i className="fa fa-trash-o"></i>
                        </button>
                    }



                </div>
            </td>

        </tr>
    );

}
